import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { ScreenLoading } from '@/components/loading';
import { ScreenError } from '@/components/screen-error';
import { ScreenCatalog } from '@/components/screens/catalog-screen';
import { useApplications, useMe } from '@/hooks/use-applications';
import { useCatalogPrefs } from '@/store/catalog-prefs';
import { useScreenProps } from '@/store/theme';

/**
 * Compatibilidade com a rota antiga `/catalog/homolog` (favoritos de navegador,
 * links colados no Teams): seleciona a aba de homologação no store persistido e
 * leva para `/catalog` — a aba agora é preferência do usuário, não rota.
 */
export function CatalogHomologRedirect() {
  const setView = useCatalogPrefs((s) => s.setView);
  useEffect(() => {
    setView('homolog');
  }, [setView]);
  return <Navigate to="/catalog" replace />;
}

export function CatalogPage() {
  const sp = useScreenProps();
  const {
    data: apps,
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
    dataUpdatedAt,
  } = useApplications();
  const { data: me } = useMe();
  const role = me?.role === 'admin' ? 'admin' : 'collab';

  // Erro ANTES do loading: sem isso a entrada do app fica em spinner infinito
  // quando a query falha (isLoading volta a false, mas `apps` segue undefined).
  if (isError && !apps) {
    return (
      <ScreenError
        error={error}
        onRetry={() => void refetch()}
        retrying={isFetching}
        active="catalog"
        role={role}
        title="Catálogo"
        subtitle="Aplicações da Masterboi disponíveis para você"
      />
    );
  }
  if (isLoading || !apps) return <ScreenLoading dark={sp.dark} />;

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenCatalog {...sp} apps={apps} role={role} updatedAt={dataUpdatedAt} />
    </div>
  );
}
